<template>
	<v-container class="ma-0 pa-0 steps_container" fill-height>
		<v-row dense class="ma-0 pa-0 px-7">
			<v-col cols="12" align-self="start" class="steps_title_descript">
				<p class="steps_count">3/8</p>
				<p v-if="checkUp.smkStatType == '2'">
                	금연 전 평균<br />
                	<span class="steps_bolder_words">하루 흡연량</span>은<br/>
                	몇 개비였나요?
				</p>
				<p v-else>
					현재 흡연 중이라면, 평균<br />
					<span class="steps_bolder_words">하루 몇 개비</span> 를<br/>
					피우시나요?
				</p>
			</v-col>
		</v-row>

		<v-row dense class="ma-0 pa-0 py-4">
			<v-col cols="12" align-self="center" align="center" class="pa-0 ma-0"></v-col>
		</v-row>

		<v-row dense class="ma-0 pa-0 px-7">
			<v-col cols="12" align-self="center" align="center" class="pa-0 slider-img">
				<span class="type-span">{{ Number(smkQty) }}</span>
			</v-col>
			<v-col cols="12" align-self="center" align="center" class="px-auto mx-auto">
				<slide-picker
                    ref="picker"
                    suffix="개비"
                    :items="items"
                    :initial-index="0"
                    :tab-index="1"
                    @value="onValue"
                />
			</v-col>
		</v-row>

        <v-container class="pa-0 ma-0 mt-16 footer_btn_group">
			<v-row class="ma-0 pa-0">
				<v-col cols="3" class="ma-0 pa-0">
					<v-btn
						elevation="0"
						class="tearms_cancel_btn"
						block
						tabindex="8"
						@click="previous"
						tile
						v-ripple
					>
						이전
					</v-btn>
				</v-col>
				<v-col cols="9" class="ma-0 pa-0">
                    <v-btn
						elevation="0"
						block
						:class="this.enableButton ? 'tearms_start_enable_btn' : 'tearms_start_disable_btn'"
						tabindex="9"
						@click="next"
						tile
						v-ripple
					>
						다음
					</v-btn>
				</v-col>
			</v-row>
        </v-container>
	</v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { bus } from "@/main";
import SlidePicker from '../../components/SlidePicker';

export default {
    components: {SlidePicker},
    data: () => ({
		enableButton: true,
        smkQty: '1', // 하루 흡연량 1~99개비,
        items: Array.range(1, 100)
	}),

	methods: {
        ...mapActions('survey', [
			'setCheckupTemp',
			'setStep'
        ]),
		previous() {
			this.setStep(6)
			this.$router.push("/checkup/step61");
		},
		next() {
			const params = {
				step: 62,
				smkQty: this.smkQty
            };
            this.setCheckupTemp(params);
			this.setStep(7)
			this.$router.push("/checkup/step7");
		},
        onValue ({ value }) {
            this.smkQty = value
		},
		async restoreData() {
            await this.$nextTick()
			if (this.checkUp.smkQty != null && "" != this.checkUp.smkQty) {
				this.smkQty = this.checkUp.smkQty;
				this.$refs.picker.setPosition(this.smkQty)
			}
		}
    },
	computed: {
		...mapGetters("survey", {
			checkUp: "checkUp"
		})
	},
	mounted() {
		window.scrollTo(0, 0)
		this.setStep(6)
		this.restoreData()
	}
};
</script>

<style scoped>
    .slider-img {
		height: 127px;
		/* width: 32vw; */
		max-width: 500px;
        background: url(~@/assets/images/ic-num-cigarette.png) no-repeat;
        background-size: contain;
		background-position: center center;
    }

	.type-span {
		line-height: 5.5;
		display: flex;
		justify-content: center;
		align-items: center;
		font-family: "NanumSquare", sans-serif;
        font-weight: 700;
		font-size: 28px;
		letter-spacing: -0.36px;
		text-align: center;
		color: #ffffff;
	}

	.tearms_cancel_btn {
		height: 60px !important;
		background-color: #dcdfe6 !important;
		color: #193263;
		font-weight: 700;
        font-family: NanumSquare, sans-serif !important;
	}

	.tearms_start_enable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif;
        color: white !important;
		border: 0;
		outline: none;
	}

	.tearms_start_disable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif !important;
        color: white !important;
		border: 0;
		outline: none;
    }

	::v-deep .tearms_start_disable_btn .v-btn__content {
		color: white !important;
	}

	::v-deep .tearms_start_enable_btn .v-btn__content {
		color: white !important;
	}

	.terms_container {
		word-break: keep-all;
        align-items: baseline !important;
    }

	@media screen and (max-height: 759px)
    {   
        .intro_title_img{
            margin-top:0;
        }
    }


</style>
